<app-carousel-simple [shownCount]="settings?.showSize ?? '4'" [gap]="(settings.gap ?? 20)+'px'">
    <ng-container *ngFor="let section of layout">
        <ng-container *lazyLoad="section?.alias; data: section; error: error"></ng-container>
        <ng-template #error>List Element Not Found: {{ section?.alias }}</ng-template>
    </ng-container>
</app-carousel-simple>
